/** Block Examples Library v2 client-side representation readers. */

import type { BlockLibraryExampleDoc } from '@modules/shared-types';

export interface ExampleInstructionEntry {
  level: string;
  text: string;
}

/** Exact full screens used only by the library preview UI. */
export function examplePreviewScreens(doc: BlockLibraryExampleDoc): Array<Record<string, unknown>> {
  return Array.isArray(doc.previewScreens)
    ? (doc.previewScreens as unknown[]).filter(
      (screen): screen is Record<string, unknown> => Boolean(screen && typeof screen === 'object'),
    )
    : [];
}

/** Semantic rationale from the blueprint, with card description fallback. */
export function exampleRationale(doc: BlockLibraryExampleDoc): string {
  const rationale = typeof doc.blueprint?.strategicBlock?.description === 'string'
    ? doc.blueprint.strategicBlock.description.trim()
    : '';
  return rationale || String(doc.description ?? '').trim();
}

/** Leveled instructions from the semantic blueprint. */
export function exampleInstructions(doc: BlockLibraryExampleDoc): ExampleInstructionEntry[] {
  if (!Array.isArray(doc.blueprint?.instructions)) return [];
  return doc.blueprint.instructions
    .map((item) => {
      const record = item as unknown as Record<string, unknown>;
      const text = typeof record.text === 'string' ? record.text.trim() : '';
      if (!text) return null;
      return { level: String(record.level ?? 'should'), text };
    })
    .filter((entry): entry is ExampleInstructionEntry => entry !== null);
}
